import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMyDiscovery } from '@/actions/my-discovery/getMyDiscovery';
import { MyDiscoveryResponse } from '@/types/discovery.status.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetMyDiscoveryReturn {
  result: ApiResponse<MyDiscoveryResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetMyDiscovery = (): UseGetMyDiscoveryReturn => {
  const query: UseQueryResult<
    ApiResponse<MyDiscoveryResponse>,
    Error
  > = useQuery({
    queryKey: ['my-discovery'],
    queryFn: getMyDiscovery,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
